import Icon from '@material-ui/icons/PeopleOutline';

export default Icon;